module.exports = __webpack_public_path__ + "static/media/qa.29cc2833.svg";